module.exports = __webpack_public_path__ + "img/مانغو-صورة.a0e1c1a5.png";